// SEQ=10116 P8-CK-E — Progress Card i18n loader
// 본 모듈은 한/영 JSON을 정적 import하여 lookup 함수만 노출.
// 카드 75장 × 2 필드(name/desc) × 2 언어 = 300 키.

import koJson from './progress-cards.ko.json'
import enJson from './progress-cards.en.json'

export type ProgressLang = 'ko' | 'en'

const koMap: Record<string, string> = koJson as unknown as Record<string, string>
const enMap: Record<string, string> = enJson as unknown as Record<string, string>

/** 진보카드 i18n lookup. fallback: CARD_TYPE 그대로 (영문 식별자). */
export function progressName(cardType: string, lang: ProgressLang = 'ko'): string {
  const key = `progress.${cardType}.name`
  const map = lang === 'ko' ? koMap : enMap
  return map[key] ?? cardType
}

export function progressDesc(cardType: string, lang: ProgressLang = 'ko'): string {
  const key = `progress.${cardType}.desc`
  const map = lang === 'ko' ? koMap : enMap
  return map[key] ?? ''
}

/** 한/영 병기 표시: "한글명 (English)". */
export function progressNameDual(cardType: string): string {
  const ko = progressName(cardType, 'ko')
  const en = progressName(cardType, 'en')
  if (ko === en) return ko
  return `${ko} (${en})`
}
